import getCloudinarySdk from "./getCloudinarySdk";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { format, quality } from "@cloudinary/url-gen/actions/delivery";
import {
  SMALL_VIEWPORT,
  MEDIUM_VIEWPORT,
  LARGE_VIEWPORT
} from "../../state/modules/layout";

const getVideoUrl = videoAssetId =>
  getCloudinarySdk()
    .video(videoAssetId)
    .delivery(format("auto:video"))
    .delivery(quality("auto:good"))
    .resize(fill())
    .toURL();

const mobileVideoUrlTemplateFactory = featuredHeaderData =>
  getVideoUrl(featuredHeaderData.app.videoAssetId);

const desktopVideoUrlTemplateFactory = featuredHeaderData =>
  getVideoUrl(featuredHeaderData.web.videoAssetId);

const VIEWPORT_CATEGORY_TO_VIDEO_URL_TEMPLATE_FACTORY_MAP = {
  [SMALL_VIEWPORT]: mobileVideoUrlTemplateFactory,
  [MEDIUM_VIEWPORT]: desktopVideoUrlTemplateFactory,
  [LARGE_VIEWPORT]: desktopVideoUrlTemplateFactory
};

export const generateVideoUrl = (viewportCategory, featuredHeaderData) =>
  VIEWPORT_CATEGORY_TO_VIDEO_URL_TEMPLATE_FACTORY_MAP[viewportCategory](
    featuredHeaderData
  );
